import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';

/**
 * A field-type entry in the left palette. Draggable onto the canvas;
 * dropping it there appends a new component of this type (see
 * FormBuilderPage's onDragEnd). Never sortable itself — it's a template,
 * not a canvas item.
 */
export default function PaletteItem({ type, label, icon: Icon }) {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: `palette-${type}`,
    data: { source: 'palette', type },
  });

  return (
    <button
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      type="button"
      style={{ transform: CSS.Translate.toString(transform) }}
      className={`w-full flex items-center gap-2.5 px-3 py-2.5 rounded-[4px] border border-[#D8DDE6] bg-white hover:border-[#0176D3] hover:bg-[#F4F6F9] text-left transition-colors cursor-grab active:cursor-grabbing ${isDragging ? 'opacity-40' : ''}`}
    >
      {Icon && <Icon size={15} className="text-[#706E6B] shrink-0" />}
      <span className="text-[12px] font-medium text-[#181818]">{label}</span>
    </button>
  );
}
